<template>
  <div>
    <div :id="id" style="height: 100%"></div>
    <a-radio-group
      v-model:value="carOrPerson"
      @change="fetch"
      button-style="solid"
      size="small"
      style="position: absolute; right: 10px; top: 5px; z-index: 10"
    >
      <a-radio-button :value="1" style="color: inherit">车辆</a-radio-button>
      <a-radio-button :value="2" style="color: inherit">人员</a-radio-button>
    </a-radio-group>
  </div>
</template>

<script setup>
  import * as echarts from 'echarts'
  import { ref, onMounted, defineExpose, onUnmounted, shallowRef } from 'vue'
  import { getExceedingTimeLimit } from '@/api/dashboard'
  const carOrPerson = ref(1)
  const id = 'exceedingTimeLimit'

  //初始化图表
  onMounted(initChart)
  const chart = shallowRef()
  function initChart() {
    let chartDom = document.getElementById(id)
    chart.value = echarts.init(chartDom, 'dark')
    const labelOption = {
      color: '#ffffffa8',
      // show: true,
      position: 'insideBottomRight',
      distance: 15,
      align: 'left',
      verticalAlign: 'middle',
      rotate: 90,
      // formatter: '{c}  {name|{a}}',
      fontSize: 16,
      rich: {
        name: {},
      },
    }

    const option = {
      backgroundColor: 'rgba(0, 0, 0, 0)', // 透明背景色
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      legend: {
        data: ['超时未出园', '超时未入园统计'],
        left: '10px',
        top: '5px',
      },
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          // data: ['2012', '2013', '2014', '2015', '2016'],
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: [
        {
          name: '超时未出园',
          type: 'bar',
          barGap: 0,
          label: labelOption,
          emphasis: {
            focus: 'series',
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: '#FF0087', // 原本颜色
                },
                {
                  offset: 1,
                  color: '#FF66A1', // 更浅的颜色
                },
              ],
            },
          },
          // data: [320, 332, 301, 334, 390],
        },
        {
          name: '超时未入园统计',
          type: 'bar',
          label: labelOption,
          emphasis: {
            focus: 'series',
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: '#FFBF00', // 原本颜色
                },
                {
                  offset: 1,
                  color: '#FFE066', // 更浅的颜色
                },
              ],
            },
          },
          // data: [220, 182, 191, 234, 290],
        },
      ],
    }

    chart.value && chart.value.setOption(option)
  }

  //请求数据并配置图表数据
  const timer = ref()
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))
  async function fetch() {
    const res = await getExceedingTimeLimit({ type: carOrPerson?.value })
    if (res.success) {
      setData(res.data)
    }
  }
  function setData(data) {
    let option = {
      xAxis: [
        {
          data: data?.xAxis || [],
        },
      ],
      series: data?.series || [],
    }

    option && chart.value.setOption(option)
  }

  defineExpose({ chart })
</script>

<style lang="less" scoped></style>
